import i from "./index.es19.js";
import n from "./index.es20.js";
function l(f, o) {
  return f.filter((e) => !i(e)).map((e, r) => {
    let t;
    return typeof o == "function" && (t = o(e, r), t === null || t) ? t : n(e, r, o);
  });
}
export {
  l as default
};
//# sourceMappingURL=index.es18.js.map
